module.exports = __webpack_public_path__ + "static/media/1_12.8ce5fc75.jpg";